module.exports = __webpack_public_path__ + "static/media/06_genderless.14f27a7a.jpg";